import { ContextMenuItemView, UnitContextMenuClickParams } from '@mark43/cad-api';
import { observer } from 'mobx-react-lite';
import { ContextMenuItem } from '../context-menus/components/context-menu-item';
import { useReleaseUnit } from '../common/hooks/use-release-unit';
import { useReleaseUnitsMutation } from './use-release-units-mutation';
import { createApiErrorHandler } from '@m43/core';
import { useToast } from '@cad-arc';
import { errorOccurredWhile } from '../common/helpers/error-occurred-while';
import { useCallback } from 'react';

export const ReleaseItem = observer(function ReleaseItem({
    contextMenuItemView,
    clickParams,
}: {
    contextMenuItemView: ContextMenuItemView;
    clickParams: UnitContextMenuClickParams;
}): React.ReactElement {
    const releaseUnitsMutation = useReleaseUnitsMutation();
    const toast = useToast();
    const releaseCallback = useCallback(
        () =>
            releaseUnitsMutation.mutateAsync([clickParams.unitId]).catch(
                createApiErrorHandler(() => {
                    toast({
                        status: 'error',
                        description: errorOccurredWhile('releasing unit'),
                    });
                })
            ),
        [clickParams.unitId, releaseUnitsMutation, toast]
    );

    const releaseUnit = useReleaseUnit({ ...clickParams });
    return (
        <ContextMenuItem
            dataPendoId="menu-item-release"
            contextMenuItemView={contextMenuItemView}
            onSelect={() => {
                releaseUnit({ callback: releaseCallback });
            }}
        />
    );
});
